import { getElements } from '../utils/functional'
const isIE11 = !!window.MSInputMethodContext && !!document.documentMode

if (isIE11) {
  const els = getElements('[data-object-fit]')

  els.forEach(function (el) {
    const imgUrl = el.querySelector('img').getAttribute('src')
    if (imgUrl) {
      el.style.backgroundImage = `url(${imgUrl})`
      el.classList.add('util-ObjectFit')
    }
  })
}
